// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__31vr-","colCheckbox":"styles_colCheckbox__ZJG0U"};